import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

/**
 * Connection problems: time out and retry (PRODUCT_DECISIONS, 2026-10-23). Shown in place of
 * the start-up spinner when UserContext could not reach the server, so a stalled backend
 * ends in a message and a Retry instead of a spinner that never stops.
 */
const ConnectionProblemScreen = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div className="text-center max-w-sm" role="alert" data-testid="connection-problem-screen">
      <ExclamationTriangleIcon className="w-10 h-10 text-yellow-500 mx-auto mb-3" aria-hidden="true" />
      <h1 className="text-lg font-semibold text-gray-900">Couldn't connect</h1>
      <p className="mt-2 text-sm text-gray-600">Check your connection and try again.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-4 px-4 py-2 rounded-lg text-sm font-medium text-white bg-primary-600 hover:bg-primary-700"
      >
        Retry
      </button>
    </div>
  </div>
);

export default ConnectionProblemScreen;
